

export const domain = 'https://acos-beck-end.vercel.app'
